import { FormFileUpload } from '@ami/react/core';
import { FormInput } from '@ami/react/core';
import CustomQuoteDocument from '../../../documents/customQuoteDocument';
import PropTypes from 'prop-types';
import React from 'react';
import { Form } from 'reactstrap';

const CustomDocumentData = ({ customDocument, customDocumentChanged }) => {
  const { name, fileName } = customDocument;
  const updateCustomDocument = (updateObject) =>
    customDocumentChanged(
      new CustomQuoteDocument({ ...customDocument, ...updateObject })
    );

  return (
    <div className="quote-document-form">
      <div className="row">
        <div className="col">
          <FormInput
            autoFocus
            id="name"
            label="Name"
            value={name}
            onChange={(e) => updateCustomDocument({ name: e.target.value })}
          />
        </div>
      </div>
      <div className="row">
        <div className="col">
          <FormFileUpload
            label="File"
            hideUploadAfterFile={true}
            onFileUploaded={(fileInfo) =>
              updateCustomDocument({
                fileKey: fileInfo.key,
                fileName: fileInfo.name,
              })
            }
          >
            {fileName}
          </FormFileUpload>
        </div>
      </div>
    </div>
  );
};

class AddCustomDocumentForm extends React.PureComponent {
  static propTypes = {
    customDocument: PropTypes.instanceOf(CustomQuoteDocument).isRequired,
    customDocumentChanged: PropTypes.func.isRequired,
  };

  render() {
    const { customDocument, customDocumentChanged } = this.props;
    return (
      <Form>
        <CustomDocumentData
          customDocument={customDocument}
          customDocumentChanged={customDocumentChanged}
        />
      </Form>
    );
  }
}

export default AddCustomDocumentForm;
